import { AxiosResponse } from 'axios';
import { axiosInstance } from '..';

export function getHesEvaluation(
  supplierIds?: string,
  categories?: string,
  startDate?: string,
  endDate?: string
): Promise<AxiosResponse<any, any>> {
  const params: Record<string, string> = {};
  if (supplierIds) params.supplierIds = supplierIds;
  if (categories) params.categories = categories;
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  return axiosInstance.get(`Evaluation/LastHesValue`, {
    params,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getSupplierPosition(categoryId: string, supplierId: string): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`Evaluation/GetSupplierPosition/${categoryId}/${supplierId}`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}
